export default "__VITE_ASSET__C5IpsvPc__"